export default "__VITE_ASSET__BqBw4k9U__"